module.exports = __webpack_public_path__ + "d292a9a246fd658e4dafcc061fc716a1.MP3";